import React, { useState, useEffect } from 'react';
import {
  string, number, func, shape, bool
} from 'prop-types';
import { TextField, Checkbox } from '@one-thd/sui-atomic-components';
import { cleanQuantity } from '../../AddToHelpers';

export const IntentItem = ({ item, onUpdate }) => {
  const { id, intent, quantity, isSelected = true } = item;
  const [editedName, setEditedName] = useState(intent);
  const [editedQuantity, setEditedQuantity] = useState(cleanQuantity(quantity));
  const [previousQuantity, setPreviousQuantity] = useState(cleanQuantity(quantity));

  // Update local state when props change
  useEffect(() => {
    setEditedName(intent);
  }, [intent]);

  useEffect(() => {
    const cleanedQty = cleanQuantity(quantity);
    setEditedQuantity(cleanedQty);
    setPreviousQuantity(cleanedQty);
  }, [quantity]);

  const handleNameChange = (event) => {
    const newName = event.target.value;
    setEditedName(newName);
    if (onUpdate) {
      onUpdate(id, {
        intent: newName,
        quantity: editedQuantity,
        isSelected
      });
    }
  };

  const handleQuantityChange = (event) => {
    const value = event.target.value;
    // Allow empty string or valid numbers
    if (value === '' || value === null || value === undefined) {
      setEditedQuantity('');
    } else {
      const numValue = parseInt(value, 10);
      if (!Number.isNaN(numValue)) {
        setEditedQuantity(numValue);
      }
    }
  };

  const handleQuantityBlur = () => {
    // When user leaves the field, validate and apply constraints
    if (editedQuantity === '' || editedQuantity === null || editedQuantity === undefined) {
      // If empty, revert to previous value
      setEditedQuantity(previousQuantity);
    } else {
      // Clean and validate the quantity
      const cleanedQuantity = cleanQuantity(editedQuantity);
      setEditedQuantity(cleanedQuantity);
      setPreviousQuantity(cleanedQuantity);

      // Update parent component
      if (onUpdate) {
        onUpdate(id, {
          intent: editedName,
          quantity: cleanedQuantity,
          isSelected
        });
      }
    }
  };

  const handleSelectionChange = (event) => {
    const newIsSelected = event.target.checked;
    if (onUpdate) {
      onUpdate(id, {
        intent: editedName,
        quantity: editedQuantity,
        isSelected: newIsSelected
      });
    }
  };

  return (
    <div
      className="sui-flex sui-justify-between sui-items-center sui-gap-2 sui-px-2"
    >
      <div className="sui-flex sui-items-center sui-gap-2 sui-pt-1">
        <Checkbox
          checked={isSelected}
          onChange={handleSelectionChange}
          aria-label={`Select ${editedName || 'item'}`}
          id={`select-group-item-${id}`}
        />
      </div>
      <div className="sui-flex-1">
        <TextField
          value={editedName}
          onChange={handleNameChange}
          placeholder="Item name"
          fullWidth
        />
      </div>
      <div className="sui-w-20 sui-text-center">
        <TextField
          type="number"
          value={String(editedQuantity)}
          onChange={handleQuantityChange}
          onBlur={handleQuantityBlur}
        />
      </div>
    </div>
  );
};

IntentItem.propTypes = {
  item: shape({
    id: string.isRequired,
    intent: string.isRequired,
    quantity: number.isRequired,
    isSelected: bool.isRequired
  }).isRequired,
  onUpdate: func.isRequired
};
